import React from "react";
import { X, Check } from "lucide-react";

export default function Comparison() {
  const beforePoints = [
    "Svegliarsi nell'ansia, controllando continuamente l'ultimo accesso di WhatsApp.",
    "Adattarsi e tollerare comportamenti tossici pur di non perderlo.",
    "Elemosinare briciole di attenzione e affetto, giustificando ogni sua assenza.",
    "Sentirsi esausta, prosciugata, insicura e priva di direzione.",
    "Rincorrere un uomo credendo di poter cambiare lui o la relazione."
  ];

  const afterPoints = [
    "Svegliarsi con un senso profondo di *calma, pace interiore e chiarezza mentale*.",
    "Riconoscere e *bloccare istantaneamente* comportamenti che violano i tuoi *confini*.",
    "Scegliere di investire il tuo tempo solo in *relazioni reciprocamente mature e nutrienti*.",
    "Sentirsi *centrata, sicura del proprio valore* e padrona delle proprie decisioni.",
    "Diventare la donna che, con *grazia ed eleganza*, non accetta più l'uomo sbagliato."
  ];

  const renderKeywords = (text) =>
    text.split(/(\*[^*]+\*)/g).map((part, i) =>
      part.startsWith("*") && part.endsWith("*") ? (
        <span key={i} className="text-bordeaux font-medium">{part.slice(1, -1)}</span>
      ) : (
        part
      )
    );

  return (
    <section className="py-24 md:py-32 bg-cream border-y border-chocolate/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-16">
        
        {/* Title */}
        <div className="text-center space-y-4 max-w-2xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-bordeaux">
            LA TRASFORMAZIONE
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-chocolate font-editorial">
            Cosa cambia <span className="italic">in <span className="text-champagne">60 giorni</span></span>
          </h2>
          <p className="text-sm sm:text-base leading-relaxed text-chocolate/70 font-light">
            Ecco la reale differenza tra chi vive in uno stato di costante dipendenza emotiva e chi sceglie di riprendere le redini del proprio valore.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Prima - Emotional Burden */}
          <div className="bg-bordeaux p-10 border border-champagne/30 space-y-8">
            <div className="space-y-2">
              <span className="text-xs tracking-widest text-champagne font-bold uppercase block">PRIMA DEL PERCORSO</span>
              <h3 className="text-2xl font-normal text-ivory font-editorial">La disconnessione da sé</h3>
            </div>
            <ul className="space-y-6">
              {beforePoints.map((point, idx) => (
                <li key={idx} className="flex items-start space-x-4">
                  <X className="w-5 h-5 text-champagne shrink-0 mt-0.5" />
                  <p className="text-sm sm:text-base text-ivory/85 font-light leading-relaxed">{point}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Dopo - Emotional Sovereignty */}
          <div className="bg-white p-10 border-l-4 border-l-bordeaux border-y border-r border-chocolate/10 space-y-8 shadow-sm">
            <div className="space-y-2">
              <span className="text-xs tracking-widest text-bordeaux font-bold uppercase block">DOPO IL PERCORSO</span>
              <h3 className="text-2xl font-normal text-chocolate font-editorial">Il ritorno al centro</h3>
            </div>
            <ul className="space-y-6">
              {afterPoints.map((point, idx) => (
                <li key={idx} className="flex items-start space-x-4">
                  <Check className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
                  <p className="text-sm sm:text-base text-chocolate/90 font-light leading-relaxed">{renderKeywords(point)}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
}
